var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEuropeTripPlaneContrast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6131 29.1065C62.3954 28.084 57.7198 30.3846 55.9092 31.6626L67.4119 36.2955C68.903 34.3252 70.8307 30.1289 66.6131 29.1065Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9965 28.0537L16.8999 27.9065L16.7298 27.8607C14.9755 27.3883 12.9291 27.4923 11.1134 27.7951C9.29102 28.0991 7.65338 28.6117 6.69218 28.9962L6.42338 29.1037L6.40238 29.3924C6.07509 33.8927 7.7051 40.0036 9.68742 45.1296C10.6822 47.702 11.7743 50.0483 12.7723 51.8472C13.271 52.7462 13.75 53.5154 14.1855 54.1103C14.6099 54.69 15.0278 55.1536 15.4127 55.3846C15.6137 55.5052 15.8925 55.6094 16.2105 55.7042C16.5364 55.8013 16.9344 55.8972 17.3925 55.992C18.309 56.1816 19.4903 56.3717 20.8653 56.5596C23.6166 56.9355 27.1695 57.3056 30.9867 57.6454C38.6219 58.325 47.3358 58.8846 52.8548 59.1246C61.7501 59.5113 70.9226 55.8738 74.4575 53.9813C75.7095 53.6232 77.5743 52.9282 79.1757 51.9789C79.9869 51.4981 80.7483 50.9417 81.3288 50.3166C81.9078 49.6931 82.335 48.9703 82.412 48.1618C82.49 47.3431 82.1766 46.5441 81.6894 45.8188C81.2001 45.0904 80.5072 44.3932 79.7472 43.7601C78.2612 42.5222 76.4544 41.4762 75.2076 40.8718C67.9917 32.6701 57.6249 30.2054 47.6645 30.4248C37.8659 30.6405 28.3895 33.4527 22.5108 36.0416C20.6201 33.4904 18.0716 29.6919 16.9965 28.0537Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 0.925926
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8088 53.2165C72.7661 49.4498 73.9995 44.3256 74.878 41.8018C74.9848 41.4951 75.3258 41.3466 75.6193 41.4855C78.2656 42.7384 82.5089 46.0425 81.9497 48.2794C81.236 51.134 76.8699 52.9647 74.4648 53.5912C74.1785 53.6658 73.8877 53.5016 73.8088 53.2165Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.708 45.3172C72.3015 48.9847 60.3161 51.2781 47.0134 51.2781C31.5729 51.2781 17.9074 48.1884 9.55273 43.4465C11.6252 49.2263 14.3348 54.1996 15.6497 54.9885C18.0461 56.4264 41.8503 58.1837 52.8737 58.663C61.6924 59.0464 70.82 55.4145 74.2814 53.5507C76.7311 52.8584 81.6943 50.8028 81.9499 48.1189C82.0379 47.1946 81.5222 46.2311 80.708 45.3172Z",
    fill: "#1E1E1E"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1923 50.1936C51.5512 48.4329 41.681 47.8685 36.8502 47.8002C36.6992 47.798 36.5606 47.8518 36.4506 47.9553C31.13 52.964 21.0023 62.9879 21.7611 64.2525C22.7196 65.8501 25.116 65.8501 29.11 65.5306C33.104 65.211 57.5472 52.4303 54.1923 50.1936Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 0.925926
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0108 33.2587C14.7552 32.7474 10.8571 32.1936 8.93997 31.9806C6.17081 33.5249 2.98961 36.5941 4.30695 37.2527C6.22431 38.2112 15.3304 33.8977 15.0108 33.2587Z",
    fill: "#1E1E1E",
    stroke: "white",
    strokeWidth: 0.925926
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3095 41.4899L74.315 41.4863C74.6276 41.2818 74.664 40.8423 74.3924 40.5858L72.0456 38.3693L69.36 36.3905C69.1523 36.2375 68.8694 36.2376 68.6654 36.3956C67.0992 37.608 64.4957 39.8582 64.3771 40.9255C64.2629 41.953 66.605 44.5019 68.169 46.0211C68.4354 46.2799 68.8706 46.2173 69.09 45.9176C70.5142 43.9725 72.8912 42.4176 74.3095 41.4899Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 0.925926
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.0991,
    cy: 43.9642,
    rx: 2.55615,
    ry: 2.55615,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.7671,
    cy: 43.9642,
    rx: 2.55615,
    ry: 2.55615,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.0747,
    cy: 43.9642,
    rx: 2.55615,
    ry: 2.55615,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEuropeTripPlaneContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EuropeTripPlaneContrast.5ab8ad9032ae7cf24beca810d022c337.svg";